import { useQuery } from 'react-query'
import { api } from '../api'
import { QueryKeyEnum } from '../../enums/QueryKeyEnum'
import { ApiUrlEnum } from '../../enums/ApiUrlEnum'
import { IUserEntity } from '../../interfaces/IUserEntity'

export const useGetCurrentUser = () => {
  return useQuery(QueryKeyEnum.CURRENT_USER, () => api.get<IUserEntity>(ApiUrlEnum.AUTH))
}
